let debugMode = false;
let verboseMode = false;
const verboseEvents = ['timeupdate', 'adprogress'];
export function enableDebugMode(debugLevel) {
    verboseMode = debugLevel === 'verbose';
    debugMode = true;
}
export function disableDebugMode() {
    debugMode = false;
}
export function debug(msg, ...args) {
    if (!debugMode) {
        return;
    }
    if (!verboseMode && verboseEvents.some(event => msg.includes(event))) {
        return;
    }
    console.debug(`[web-media-player] ${msg}`, ...args);
}
